module.exports = __webpack_public_path__ + "support_beer.a11d66e1.png";